<template>
  <div>
    <v-layout class="mt-3">
      <v-flex xs6 class="mr-1">
        <v-select
          @change="changeDayTime"
          hide-details
          outlined
          dense
          placeholder="Day"
          :items="days"
          v-model="day"
        >
        </v-select>
      </v-flex>
      <v-flex class="ml-1">
        <v-text-field
          dense
          placeholder="Time"
          outlined
          readonly
          hide-details
          v-model="formattedTime"
          @click="openTimeSelectDialog"
        >
        </v-text-field>
        <!-- <v-btn icon @click="openTimeSelectDialog">
          <v-icon> mdi-clock </v-icon>
        </v-btn> -->
      </v-flex>
      <v-flex xs1 text-right>
        <v-btn color="error" icon @click="deleteDayTime">
          <v-icon> mdi-delete </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="290">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex>
              <div>Select Time</div>
            </v-flex>
            <v-flex text-right>
              <v-btn @click="dialog = false" icon>
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-time-picker v-model="time" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancel"
            color="error"
            class="text-none subtitle-2"
            outlined
          >
            Cancel
          </v-btn>
          <v-btn color="primary" class="text-none subtitle-2" @click="save">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      },
    },
    index: {
      type: Number,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      //   timeTrailing: "",
      dialog: false,
      day: "",
      time: "00:00",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    };
  },
  computed: {
    timeTrailing() {
      if (Number(this.time.substr(0, 2)) > 12) {
        return "PM";
      } else {
        return "AM";
      }
    },
    formattedTime() {
      return this.iMoment(this.time);
    },
  },
  mounted() {
    console.log(this.details);
    this.day = this.details.day;
    this.time = this.details.time;
  },
  methods: {
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp;
        return moment(temp, "HH:mm").format("LT");
      } else {
        return 0;
      }
    },
    openTimeSelectDialog() {
      this.dialog = true;
    },
    cancel() {
      this.time = "00:00";
      this.dialog = false;
    },
    changeDayTime() {
      this.$emit("changeDayTime", {
        index: this.index,
        value: {
          index: this.days.indexOf(this.day),
          day: this.day,
          time: this.time,
        },
      });
    },
    deleteDayTime() {
      this.$emit("deleteDayTime", {
        index: this.index,
      });
    },
    save() {
      this.changeDayTime();
      this.dialog = false;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style>
</style>